import { useState, useEffect } from 'react';
import './Countdown.css';

export default function Countdown({ targetDate, mode = 'opening' }) {
  const [time, setTime] = useState({ days:0, hours:0, minutes:0, seconds:0, expired:false });

  useEffect(() => {
    const target = new Date(targetDate);
    const calc = () => {
      const diff = target - new Date();
      if (diff <= 0) { setTime({ days:0,hours:0,minutes:0,seconds:0,expired:true }); return; }
      setTime({
        days: Math.floor(diff / 86400000),
        hours: Math.floor((diff % 86400000) / 3600000),
        minutes: Math.floor((diff % 3600000) / 60000),
        seconds: Math.floor((diff % 60000) / 1000),
        expired: false,
      });
    };
    calc();
    const id = setInterval(calc, 1000);
    return () => clearInterval(id);
  }, [targetDate]);

  const pad = n => String(n).padStart(2, '0');
  const label = mode === 'opening' ? 'Ouverture des candidatures dans' : 'Clôture des candidatures dans';

  const units = [
    { val: pad(time.days),    lbl: 'Jours'  },
    { val: pad(time.hours),   lbl: 'Heures' },
    { val: pad(time.minutes), lbl: 'Min'    },
    { val: pad(time.seconds), lbl: 'Sec'    },
  ];

  return (
    <div className="countdown">
      <div className="countdown__label">{label}</div>
      {time.expired ? (
        <div className="countdown__expired">
          {mode === 'opening' ? '🎉 Les candidatures sont ouvertes !' : 'Les candidatures sont clôturées.'}
        </div>
      ) : (
        <div className="countdown__grid">
          {units.map((u, i) => (
            <div key={u.lbl} className="countdown__unit-wrap">
              <div className="countdown__unit-inner">
                <div className="countdown__flip">
                  <span>{u.val}</span>
                </div>
                <div className="countdown__unit-label">{u.lbl}</div>
              </div>
              {i < units.length - 1 && (
                <div className="countdown__sep">:</div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
